import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getFetch } from "../../../../../../fetch/fetch";
import ShopSalaryRegister2 from "./shopsalaryregister2";

const ShopSalaryTotal2: React.FC<any> = (props) => {

    const [options, setOptions] = useState<Array<any>>([]);
    const [selectedUser, setSelectedUser] = useState<any>(null);

    useEffect(() => {
        getStaff();
    }, []);

    const getStaff = async () => {
        try{

            const result : any = await getFetch("/dashboard/salary/getstafflist");

            console.log(result);

            const rows : any = [];

            if(result.message === "success"){
                result.data.forEach((item : any) => {

                    const newRow : any = {};

                    newRow.id = item.id;
                    newRow.label = item.name;
                    newRow.name = item.name;
                    newRow.location = item.location;
                    newRow.academy = item.academy;

                    rows.push(newRow);

                })
                setOptions(rows);
            }

        }catch(e){
            console.log(e);
        }
    }

    const onChange = (e: any, value: any) => {
        console.log(value);

        setSelectedUser(value);
    }

    return (
        <div>
            <div style={{
                width : "250px",
                marginTop : "25px"
            }}>
                <Autocomplete
                    options={options}
                    renderInput={(params) => <TextField {...params}
                        placeholder='이름' />}
                    onChange={onChange}
                />
            </div>
            <div>
                {
                    selectedUser
                    ?
                    <>
                        <ShopSalaryRegister2 user={selectedUser} notify={props.notify} forManager={true} />
                    </>
                    :
                    ""
                }
            </div>
        </div>
    )
}

export default ShopSalaryTotal2;
